<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { ref } from 'vue';

const props = defineProps({
  label: { type: String, default: 'Acessar área do corretor' },
  variant: { type: String, default: 'floating' }, // 'floating' | 'hero'
});

const emit = defineEmits(['click']);

const handleClick = () => {
  emit('click', { source: props.variant === 'hero' ? 'hero_button' : 'floating_button' });
  const target = document.getElementById('accordionagent_area-header');
  if (target) {
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};
</script>

<template>
  <button
    type="button"
    class="z-30 flex items-center gap-2 rounded-full px-4 py-2 text-[13px] font-semibold shadow-lais-card"
    :class="
      variant === 'floating'
        ? 'fixed bottom-6 right-6 bg-lais-primary text-white hover:bg-lais-primary-deep'
        : 'inline-flex border border-lais-primary bg-white text-lais-primary'
    "
    @click="handleClick"
  >
    <span class="i-lucide-briefcase h-4 w-4" />
    {{ label }}
  </button>
</template>
